import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

const PublicRoute = ({ children }) => {
    const { isAuthenticated, auth_info } = useSelector((state) => state.auth);

    if (isAuthenticated) {
        return <Navigate to={auth_info?.route_path } replace />;
    }

    return children;
};

export default PublicRoute;